<template>
	<div>
		<div class="audio-detail-msg">
			<div class="duration-seconds" :style="{'color':color}" v-if="transform">{{seconds}} ″</div>
			<div class="audio-style" :style="{'margin-right':transform?'0':'8px','margin-left':transform?'8px':'0'}" :class="{'transform':transform,'add-animation':animation}">
				<div class="small" :style="{'border-right-color':color}"></div>
				<div class="middle" :style="{'border-right-color':color}"></div>
				<div class="large" :style="{'border-right-color':color}"></div>
			</div>
			<div class="duration-seconds" v-if="!transform" :style="{'color':color}">{{seconds}} ″</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "audioIcon",
		data() {
			return {

			};
		},
		props: {
			seconds: {
				type: Number,
				default: 0
			},
			color:{
				type:String,
				default: '#FFFFFF'
			},
			transform:{
				type:Boolean,
				default:false
			},
			animation:{
				type:Boolean,
				default:false
			},
		}
	}
</script>

<style lang="scss">
	.transform{
		transform: rotateY(180deg);
	}
	.audio-detail-msg {
		display: flex;
		align-items: center;
		cursor: pointer;
		.audio-style {
			display: flex;
			align-items: center;
			border-radius: 5px;
			.small {
				border: 5px solid #4c4c4c;
				border-top-color: transparent;
				border-left-color: transparent;
				border-bottom-color: transparent;
			}

			.middle {
				width: 18px;
				height: 18px;
				margin-left: -12px;
				opacity: 1;
			}

			.large {
				width: 28px;
				height: 28px;
				margin-left: -22px;
				opacity: 1;
			}

			&>div {
				border: 2px solid #4c4c4c;
				border-top-color: transparent;
				border-left-color: transparent;
				border-bottom-color: transparent;
				border-radius: 50%;
				box-sizing: border-box;
			}

			&.add-animation {
				.middle {
					animation: show2 1.2s ease-in-out infinite;
				}

				.large {
					animation: show3 1.2s ease-in-out infinite;
				}
			}
		}

		// 语音播放动画
		@keyframes show2 {
			0% {
				opacity: 0;
			}

			10% {
				opacity: 1;
			}

			100% {
				opacity: 0;
			}
		}

		@keyframes show3 {
			0% {
				opacity: 0;
			}

			50% {
				opacity: 1;
			}

			60% {
				opacity: 0;
			}

			100% {
				opacity: 0;
			}
		}

		.duration-seconds{
			font-size: 14px;
		}
	}
</style>
